import { Injectable } from "@angular/core";
import { HttpClient, HttpResponse, HttpParams } from "@angular/common/http";
import { SortieDialyse } from "app/models/sortie-dialyse";

@Injectable()
export class SortieDialyseService {
  private readonly apiUrl = "/api/sortie/dialyse";

  constructor(private http: HttpClient) {}

  create(sortie: SortieDialyse) {

    return this.http.post(`${this.apiUrl}`, sortie).map(data => data);
  }
  update(sortie: SortieDialyse) {
    return this.http.put(`${this.apiUrl}/${sortie.id}`, sortie).map(data => data);
  }
}



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/core/sortie-dialyse.service.ts